<template lang="pug">
  .week-day
    .week-day__time-cell(
      v-for="(cell, index) in cells" :key="index"
    )
      //- .week-day__event(:style="`height: ${cell.height}px`" @click="select(cell)")
      .week-day__event(:style="`height: ${cell.height}px; ${cell.event ? 'background: #414243; cursor: pointer;' : '' }`" @click="selectItem(cell)")
        .week-day__event-time(:style="`${cell.event ? 'color: #b9b9b9' : '' }`") {{ cell.time }}
        .week-day__event-name(:class="{ 'week-day__event-name--selected': selected }")
          span(:style="`${cell.event ? 'color: #fff' : '' }`")  {{ cell.event ? cell.event.name : '&nbsp;' }}
        //- .week-day__event-tags(:style="`${cell.event ? 'color: #b9b9b9' : '' }`") {{ cell.event ? tagsToString(cell.event.eventTags) : '&nbsp;' }}
        //- test
        .week-day__event-tags(v-if="cell.event" style="color: #b9b9b9;") 
          span(v-for="(e, index1) in cell.event.eventTags" :key="index1")
            span(:style="'line-height: 170%; border-bottom: 2px solid ' + e.color") {{ '#' + e.name }}
            span.mr-2 {{ index1 < cell.event.eventTags.length - 1 ? ', ' : ''}}
        .week-day__event-tags(v-else) &nbsp;
</template>


<script>
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('ru')

export default {
  props: {
    // date: moment,
    date: String,
    selected: Boolean
  },


  computed: {
    ...mapGetters('event', ['filteredEvents']),

    events () {
      return this.filteredEvents.filter(ev => moment(ev.eventDate).isSame(this.date, 'day'))
    },

    cells () {
      let list = []
      let current = moment(this.date).startOf('day').add(8, 'hours')
      let next = moment(this.date).startOf('day').add(9, 'hours')
      let last = moment(this.date).startOf('day').add(20, 'hours')

      const halfH = 70
      const offsetY = 0

      do {
        let event = this.findEvent(current, next)

        if (event) {
          let halfTime = moment(current).add(29, 'minutes')
          let eventDate = moment(event.eventDate)

          if (eventDate.isAfter(halfTime)) {
            list.push({
              time: current.format('HH:mm'),
              halfs: 1,
              height: halfH - offsetY / 2
            })
            current.add(30, 'minutes')
          }

          let duration = event.durability || 60
          let halfs = Math.ceil(duration / 30)
          let height = Math.floor((halfs - 1) / 2) * offsetY + halfs * halfH - offsetY / 2 * (halfs % 2)
          
          list.push({
            time: eventDate.format('HH:mm'),
            halfs,
            height,
            event
          })

          current.add(halfs * 30, 'minutes')
          next = moment(current).add(1, 'hours').startOf('hour')
        }
        else {
          let duration = next.diff(current, 'minutes')
          let halfs = Math.ceil(duration / 30)
          let height = Math.floor((halfs - 1) / 2) * offsetY + halfs * halfH - offsetY / 2 * (halfs % 2)

          list.push({
            time: current.format('HH:mm'),
            halfs,
            height
          })
          current.add(halfs * 30, 'minutes')
          next = moment(current).add(1, 'hours').startOf('hour')
        }
      } while (current.isBefore(last));
      return list
    },

    // selectedDayEvents () { 
    //   return this.filteredEvents.filter(ev => moment(ev.eventDate).isSame(this.selectedDate, 'day'))
    // },
  },


  methods: {
    ...mapMutations('event', ['selectEvent', 'resetEvent']),

    selectItem (cell) {
      let times = cell.time.split(':')
      let current = moment(this.date).hours(times[0]).minutes(times[1])
      let event = cell.event || { eventDate: current }
      this.selectEvent(event)
    },

    findEvent (timeStart, timeEnd) {
      return this.events.find(ev => moment(ev.eventDate).isBetween(timeStart, timeEnd, null, '[)'))
    },

    tagsToString (tags) {
      let list = tags.map(t => `# ${t.name}`)
      return list.sort().join(', ')
    }, 

    // select (cell) {
    //   let times = cell.time.split(':')
    //   let current = moment(this.date).hours(times[0]).minutes(times[1])
    //   let event = cell.event || { eventDate: current }
    //   this.$emit('select', event)
    // }
  }
}
</script>


<style lang="scss">
.week-day {
  &__time-cell {
    overflow: hidden; 
  }

  &__event {
    padding: 12px 8px 12px 8px;

    // display: flex;
    // align-items: center;
    // font-weight: bold;
    // padding: 0 10px;

    border-bottom: 1px solid #505254;
    background: #FFFFFF;
  }

  &__event-time {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;

    color: #757575;
  }

  &__event-name {
    margin-top: 20px;
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;

    color: #505254;

    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;

    &--selected {
      font-family: Roboto Slab;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 18px;
      /* or 100% */


      color: #314369;
    }
  }

  &__event-tags {
    margin-top: 20px;
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;


    color: #959595;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

</style>
